import { z } from 'zod';
export const RoleSchema = z.enum(['ADMIN', 'CUSTOMER']);
export const AccountStatusSchema = z.enum(['ACTIVE', 'BLOCKED']);
export const RegistrationRequestTypeSchema = z.enum([
    'REGISTER',
    'LEGACY_ACTIVATION',
    'PASSWORD_RESET',
]);
export const RegistrationRequestStatusSchema = z.enum([
    'WAITING_ADMIN',
    'WAITING_OTP',
    'VERIFIED',
    'REJECTED',
    'EXPIRED',
]);
export const PhoneE164Schema = z
    .string()
    .trim()
    .regex(/^\+84[1-9]\d{8,9}$/, 'Số điện thoại Việt Nam phải theo định dạng E.164');
export const EmailSchema = z.string().trim().email('Địa chỉ email không hợp lệ').max(255);
export const PasswordSchema = z.string().min(8).max(128);
export const OtpCodeSchema = z
    .string()
    .trim()
    .regex(/^\d{6}$/);
export const AccountSchema = z
    .object({
    id: z.string().uuid(),
    phoneE164: PhoneE164Schema,
    email: EmailSchema.nullable().default(null),
    displayName: z.string().trim().min(1).max(100).nullable(),
    role: RoleSchema,
    status: AccountStatusSchema,
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
})
    .strict();
export const AuthSessionSchema = z
    .object({
    account: AccountSchema,
    expiresAt: z.string().datetime({ offset: true }),
    requiresProfile: z.boolean(),
    requiresEmailUpdate: z.boolean().default(false),
})
    .strict();
export const LoginRequestSchema = z
    .object({
    phone: z.string().trim().min(8).max(32),
    password: PasswordSchema,
    installationId: z.string().uuid().optional(),
})
    .strict();
export const RegisterRequestSchema = z
    .object({
    phone: z.string().trim().min(8).max(32),
    email: EmailSchema.optional(),
    password: PasswordSchema,
})
    .strict();
export const PasswordResetRequestSchema = z
    .object({
    phone: z.string().trim().min(8).max(32),
    newPassword: PasswordSchema,
    email: EmailSchema.optional(),
})
    .strict();
export const RequestEmailOtpSchema = z
    .object({
    email: EmailSchema,
})
    .strict();
export const VerifyEmailOtpSchema = z
    .object({
    email: EmailSchema,
    code: OtpCodeSchema,
})
    .strict();
export const ChangePasswordRequestSchema = z
    .object({
    currentPassword: PasswordSchema,
    newPassword: PasswordSchema,
})
    .strict()
    .refine((value) => value.currentPassword !== value.newPassword, {
    message: 'Mật khẩu mới phải khác mật khẩu hiện tại.',
    path: ['newPassword'],
});
export const RegistrationRequestResultSchema = z
    .object({
    requestId: z.string().uuid(),
    requestType: RegistrationRequestTypeSchema,
    status: RegistrationRequestStatusSchema,
})
    .strict();
export const RegistrationStatusResultSchema = z
    .object({
    requestId: z.string().uuid(),
    phoneE164: PhoneE164Schema,
    email: EmailSchema.nullable().optional(),
    requestType: RegistrationRequestTypeSchema,
    status: RegistrationRequestStatusSchema,
    expiresAt: z.string().datetime({ offset: true }).nullable(),
    rejectionReason: z.string().trim().min(1).max(500).nullable(),
})
    .strict();
export const VerifyRegistrationRequestSchema = z
    .object({
    code: OtpCodeSchema,
    installationId: z.string().uuid().optional(),
})
    .strict();
export const AdminRegistrationItemSchema = z
    .object({
    id: z.string().uuid(),
    phoneE164: PhoneE164Schema,
    email: EmailSchema.nullable().optional(),
    requestType: RegistrationRequestTypeSchema,
    status: RegistrationRequestStatusSchema,
    otpCode: OtpCodeSchema.nullable(),
    attempts: z.number().int().nonnegative(),
    expiresAt: z.string().datetime({ offset: true }).nullable(),
    approvedAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
})
    .strict();
export const AdminRegistrationListSchema = z
    .object({ items: z.array(AdminRegistrationItemSchema) })
    .strict();
export const RejectRegistrationRequestSchema = z
    .object({ reason: z.string().trim().min(1).max(500) })
    .strict();
export const UpdateProfileRequestSchema = z
    .object({ displayName: z.string().trim().min(1).max(100) })
    .strict();
export const UpdateProfileResultSchema = z.object({ account: AccountSchema }).strict();
//# sourceMappingURL=auth.js.map